import { z } from "zod";

export const UpdateOrganizationSchema = z
  .object({
    name: z.string().trim().min(1).max(100),
    customerDomain: z.string().trim().min(1).max(255).optional(),
    logoUrl: z.url().nullable().optional(),
  })
  .strict();

export type UpdateOrganizationBody = z.infer<typeof UpdateOrganizationSchema>;
